'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  margin-left: 15px;\n  width: 50px;\n  line-height: 18px;\n  font-size: 12px;\n  color: ', ';\n  border: 2px solid ', ';\n  border-radius: 10px;\n  text-align: center;\n  font-weight: 500;\n'], ['\n  margin-left: 15px;\n  width: 50px;\n  line-height: 18px;\n  font-size: 12px;\n  color: ', ';\n  border: 2px solid ', ';\n  border-radius: 10px;\n  text-align: center;\n  font-weight: 500;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors


var Value = _styledComponents2.default.div(_templateObject, _colors.darkGrey, _colors.grey);

exports.default = Value;